<template>
  <div>
    <app-modal v-model="rolePopup" class="role-modal" no-margin>
      <role-form
        v-model="role"
        :user-id="model.userID"
        @created="createdRole"
        @updated="updatedRole"
      ></role-form>
    </app-modal>

    <div :class="{ 'border-bottom': model.userID != undefined }">
      <div class="columns">
        <div class="column field is-3">
          <label class="label">First Name</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.firstName"
                autocomplete="off"
                class="input"
                type="text"
                :disabled="!isEdit"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="column field is-3">
          <label class="label">Last Name</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.lastName"
                autocomplete="off"
                class="input"
                type="text"
                :disabled="!isEdit"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="column field is-4">
          <label class="label">E-mail address</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.email"
                autocomplete="off"
                class="input"
                type="text"
                :disabled="!isEdit"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          v-if="!settings && model.userID == undefined"
          class="column field is-3"
        >
          <label class="label">Password</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.password"
                autocomplete="off"
                class="input"
                type="password"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div v-if="settings" class="column field is-3">
          <label class="label">Old Password</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.oldPassword"
                autocomplete="off"
                class="input"
                type="password"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div v-if="settings" class="column field is-3">
          <label class="label">New Password</label>
          <div class="control">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <input
                v-model="model.newPassword"
                autocomplete="off"
                class="input"
                type="password"
                :class="{ 'is-danger': failed }"
              />
              <span class="help is-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div v-if="settings" class="column field is-3">
          <label class="label">&nbsp;</label>
          <div class="control">
            <button class="button is-small" @click.prevent="resetPassword">
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="model.userID != undefined" class="columns">
      <div class="column is-7 pr-30">
        <div class="level">
          <div class="level-left">
            <h2 class="page-title">USER ROLE ({{ model.roles | count }})</h2>
          </div>
          <div
            v-if="!settings && (hasRole('ueg') || hasPermission(10500))"
            class="level-right"
          >
            <button class="button is-small" @click="showRolePopup">
              <span class="icon-add"></span>
            </button>
          </div>
        </div>
        <template v-for="(role, index) in model.roles">
          <user-role
            :key="index"
            v-model="model.roles[index]"
            :has-delete="!settings && (hasRole('ueg') || hasPermission(10500))"
            :has-edit="!settings && (hasRole('ueg') || hasPermission(10500))"
            :user-id="model.userID"
            @edit="showEditRolePopup"
            @deleted="deleteRole"
          ></user-role>
        </template>
      </div>
      <div class="column is-5 border-left is-hidden">
        <h2 class="page-title">USER NOTIFICATIONS</h2>
        <div class="mt-30">
          <div class="pb-30 email-me">Email me</div>

          <div class="column">
            <div
              v-for="(notification, index) in notifications"
              :key="index"
              class="field pb-15 columns notifications"
            >
              <app-checkbox v-model="notification.value" class="large">{{
                notification.label
              }}</app-checkbox>

              <div class="notifications-project-column">
                <div v-if="notification.projects" class="select">
                  <select>
                    <option value="">Any Project</option>
                    <option
                      v-for="(project, pid) in projects"
                      :key="pid"
                      :value="project.projectID"
                    >
                      {{ project.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Form from './Form.js';
import { ValidationProvider } from 'vee-validate';
import AppCheckbox from '@/components/AppCheckbox.vue';
import UserRole from '@/components/UserRole.vue';
import '@/validation.js';
import AppModal from '@/components/AppModal';
import RoleForm from '@/components/forms/RoleForm';

export default {
  name: 'UserForm',
  components: {
    ValidationProvider,
    AppCheckbox,
    UserRole,
    AppModal,
    RoleForm
  },
  extends: Form,
  props: {
    settings: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rolePopup: false,
      role: {},
      projects: [],
      permissions: [
        {
          id: 1,
          label: 'Permission 1'
        },
        {
          id: 2,
          label: 'Permission 2'
        },
        {
          id: 3,
          label: 'Permission 3'
        }
      ],
      notifications: [
        /* dummy for now */
        {
          id: 1,
          label: 'When a request is submitted from ',
          projects: false,
          value: ''
        },
        {
          id: 2,
          label: 'When a document is downloaded from',
          projects: true,
          value: ''
        },
        {
          id: 3,
          label: 'When a document is uploaded from',
          projects: false,
          value: ''
        }
      ]
    };
  },
  computed: {
    isEdit() {
      if (this.settings == false) return this.editing;
      else return false;
    } /*,
    roles() {
      const roleID = this.$store.getters.userRoleId;

      return this.$store.state.roles.filter(item => {
        return item.roleID > roleID || roleID == 10;
      });
    }*/
  },
  mounted() {
    this.projects = this.$store.getters['projects/list'];
  } /*
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.role = _.defaultsDeep(
          (this.value.roles && this.value.roles[0]) || {},
          {
            roleID: null,
            groupID: null
          }
        );
      }
    },
    role: {
      deep: true,
      handler() {
        console.log('role changed');
        (this.model.roles || (this.model.roles = []))[0] = this.role;
        // this.model.roles[0] = this.role;
      }
    }
  },*/,
  methods: {
    showRolePopup() {
      this.role = {};
      this.rolePopup = true;
    },
    showEditRolePopup(item) {
      this.rolePopup = true;
      this.role = item;
    },
    resetPassword() {
      this.$emit('reset-password');
    },
    createdRole(item) {
      this.rolePopup = false;
      this.model.roles.push(item);
      this.$store.commit('users/edit', this.model);
    },
    updatedRole(item) {
      this.rolePopup = false;
      const idx = _.findIndex(this.model.roles, {
        userRoleID: item.userRoleID
      });
      this.$set(this.model.roles, idx, item);
      this.$store.commit('users/edit', this.model);
    },
    deleteRole(item) {
      console.log('deleteRole', this.model.userID, item.userRoleID);
      if (this.model.userID && item.userRoleID) {
        this.axiosRequest(
          'delete',
          `Users/${this.model.userID}/Roles/${item.userRoleID}`
        )
          .then(() => {
            const idx = _.findIndex(this.model.roles, {
              userRoleID: item.userRoleID
            });
            this.model.roles.splice(idx, 1);
            this.$store.commit('users/edit', this.model);
            this.showPopup = false;
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notifications {
  align-items: center;
  .notifications-project-column {
    flex-shrink: 0;
    width: 180px;
  }
}

.permissions {
  padding-left: 70px;
}

.email-me {
  padding-top: 6px;
}

.border-bottom {
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: solid 1px $border;
}

.border-left {
  padding-left: 40px;
  border-left: solid 1px $border;
}
</style>
